module.exports = __webpack_public_path__ + "img/bottom_right.7cae65aa.png";